import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 리뷰 목록 조회
 * @param param
 * offset: offset
 * pageSize: pageSize
 * startDate: 시작일 YYYYMMDDHHmm
 * endDate: 종료일 YYYYMMDDHHmm
 * reviewStatus: 리뷰 유형 "total"-전체/"photo"-포토/"text"-텍스트
 * reviewGrade: 별점 0-전체/1~5-1~5점
 * benefitPayment: 혜택 지급 "total"-전체/"true"-지급/"false"-미지급
 * exposureStatus: 전시 상황 "total"-전체/"true"-정상/"false"-미노출
 * bestReview: 베스트 리뷰 여부 "total"-전체/"true"-베스트 리뷰 Y/"false"-베스트 리뷰 N
 * searchType: 상세검색 키 "product"-상품명/"product_id"-상품번호/"order_id"-상품주문번호/"review_body"-내용
 * searchText: 상세검색어
 * orderType: 정렬 기준 "created_at"-리뷰등록일순/"review_score"-평점순/"review_private"-전시상태순/"is_best"-베스트리뷰순
 * orderBy: 정렬 방향 "desc"-내림차순/"asc"-오름차순
 * userId: 사용자 아이디
 * @returns {Promise<never>}
 */
const readReviewList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userReviewHistory/admin/list`, {
    params: param,
  });
  return data;
};

/**
 * 리뷰 미노출/노출 처리
 * @param review
 * user_id: user.id
 * editList: rowkeys,
 * editkey: "review_private"/"is_best",
 * editvalue : 0-노출, 1-미노출
 * is_best: true/false
 * @returns {Promise<*>}
 */
const editReview = async (review) => {
  const { data } = await axios.post(
    `${baseUrl}/userReviewHistory/admin/review/edit`,
    review,
  );
  return data;
};

/**
 * 엑셀 리뷰 업로드
 * @param param
 * reviewList: list []
 * product_id,
 * review_body,
 * review_score,
 * created_at
 * @returns {Promise<*>}
 */
const addReviewListExcel = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userReviewHistory/list/add`,
    param,
  );
  return data;
};

/**
 * 리뷰 상세페이지 조회
 * @param param
 * @returns {Promise<never>}
 */
const getReviewDetail = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userReviewHistory/one`, {
    params: param,
  });
  return data;
};

const reviewApi = {
  readReviewList,
  editReview,
  addReviewListExcel,
  getReviewDetail,
};

export default reviewApi;
